import { PageDTO } from '@/model/PageDTO';
import { BaseService } from './base.service';
import { MenuItemDTO } from '@/model/MenuItemDTO';

export class PageService extends BaseService {
	async fetchPage(pageUrl: string): Promise<PageDTO> {
		return await this.fetch<PageDTO>(`/api/page/${pageUrl}`);
	}

	async fetchMenu(pageUrl: string) {
		return await this.fetch<MenuItemDTO[]>(`/api/page/${pageUrl}/menu`);
	}
}
